// For loading assets from CDN
// @ts-ignore
const overrideClientAssetsUrl = window.servercontext.clientAssetsUrl;
if (process.env.NODE_ENV === 'production' && overrideClientAssetsUrl) {
    // eslint-disable-next-line camelcase
    __webpack_public_path__ = overrideClientAssetsUrl;
}
